/**
 * @author        matthew@zumper.com (Matthew Talamini)
 * @copyright     Copyright (c) 2021, Zumper
 */

import { filterActions } from '@zumper/redux-ignore'

import * as constants from './constants'
import { poiReducer } from './reducers/index'

export const poiRootReducer = filterActions(poiReducer, Object.values(constants))
